import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { emphasize, withStyles, Theme } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import MuiLink from '@material-ui/core/Link';
import Link from 'next/link';
import Chip from '@material-ui/core/Chip';
import HomeIcon from '@material-ui/icons/Home';
import styled from 'styled-components';

const StyledContainer = styled(Container)`
  padding: 20px !important;
`;
const StyledBreadcrumb = withStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(Chip) as typeof Chip;

type Props = {
  pathname: string;
};
export default function IconBreadcrumbs({ pathname }: Props) {
  const pathnames = pathname.split('/').filter((x) => x);
  return (
    <StyledContainer maxWidth="lg">
      <Breadcrumbs aria-label="breadcrumb">
        <Link href="/" passHref prefetch={false}>
          <StyledBreadcrumb
            component="a"
            href="#"
            label="Home"
            icon={<HomeIcon fontSize="small" />}
          />
        </Link>

        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          return last ? (
            <Typography color="primary" key={to}>
              {value}
            </Typography>
          ) : (
            <Link key={to} href={to} prefetch={false}>
              <MuiLink color="textPrimary" key={to}>
                {/* <Typography color="textPrimary" key={to}> */}
                {value}
                {/* </Typography> */}
              </MuiLink>
            </Link>
          );
        })}
      </Breadcrumbs>
    </StyledContainer>
  );
}
